import { ScrollView, StyleSheet, View, useWindowDimensions } from 'react-native'
import { Text, useTheme } from 'react-native-paper'
import { useSelector } from 'react-redux'

import DietInformation from 'components/DietInformation'
import MealImage from 'components/MealImage'
import Ingredients from './ingredients'
import Steps from './steps'

const TimeDetail = ({ label, value }) => {
  if (!value) return null

  return (
    <Text style={styles.timeDetail}>
      {label}: {value}min
    </Text>
  )
}

const LeftContent = ({ recipe, colors, servings }) => {
  return (
    <View style={styles.container}>
      <View style={styles.imageContainer}>
        <MealImage
          style={styles.image}
          name={recipe.title}
          resizeMode="cover"
        />
      </View>
      <View style={[styles.bodyContainer, { backgroundColor: colors.surface }]}>
        <View>
          <Text style={styles.header}>{recipe.title}</Text>

          <View style={styles.timeDetailContainer}>
            <TimeDetail label="Ready in" value={recipe.readyInMinutes} />
            <TimeDetail
              label="Preparation time"
              value={recipe.preparationMinutes}
            />
            <TimeDetail label="Cook time" value={recipe.cookingMinutes} />
          </View>

          <View style={{ paddingTop: 10 }}>
            <DietInformation {...{ recipe, detailed: true }} />
          </View>
        </View>

        <Text style={styles.description}>
          {recipe.summary.replace(/(<([^>]+)>)/gi, '')}
        </Text>
        <Ingredients
          {...{
            ingredients: recipe.extendedIngredients,
            numberOfServings: servings,
            baseServings: recipe.servings,
          }}
        />
      </View>
    </View>
  )
}

const RightContent = ({ recipe }) => {
  return (
    <View style={styles.container}>
      <View style={styles.stepsContainer}>
        <Steps steps={recipe.steps} />
      </View>
    </View>
  )
}

const Web = (props) => (
  <View
    style={{
      height: '100%',
      width: '100%',
      flex: 1,
      flexDirection: 'row',
    }}
  >
    <ScrollView
      style={{
        backgroundColor: props.colors.surface,
        maxWidth: 700,
        minWidth: '35%',
      }}
      showsHorizontalScrollIndicator={false}
      disableScrollViewPanResponder={true}
    >
      <LeftContent {...props} />
    </ScrollView>
    <ScrollView
      style={{
        backgroundColor: props.colors.surface,
        paddingTop: 100,
        borderLeftWidth: 2,
      }}
      showsHorizontalScrollIndicator={false}
    >
      <RightContent {...props} />
    </ScrollView>
  </View>
)

const Mobile = (props) => (
  <ScrollView
    style={{
      height: '100%',
      flexDirection: 'column',
      backgroundColor: props.colors.surface,
    }}
  >
    <LeftContent {...props} />
    <View>
      <RightContent {...props} />
    </View>
  </ScrollView>
)

const Recipe = ({ route }) => {
  const { width } = useWindowDimensions()
  const { colors } = useTheme()
  const { servings } = useSelector(({ settings }) => settings)

  const recipe = route.params
  const props = { recipe, colors, servings }

  return width > 800 ? <Web {...props} /> : <Mobile {...props} />
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  imageContainer: {
    height: 240,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  image: {
    width: '100%',
    height: '100%',
  },
  bodyContainer: {
    flex: 1,
    flexGrow: 1,
    padding: 25,
    justifyContent: 'flex-start',
    width: '100%',
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    marginTop: -25,
  },
  header: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  description: {
    marginTop: 20,
  },
  stepsContainer: {
    width: '100%',
  },
  timeDetail: {
    fontSize: 10,
    fontWeight: 'bold',
    marginRight: 20,
  },
  timeDetailContainer: {
    width: '100%',
    justifyContent: 'flex-start',
    flexDirection: 'row',
  },
})

export default Recipe
